import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import PropTypes from 'prop-types';
import {callTargetedAction, setUpStore} from 'client/framework';
import MultipleChoiceQuestionStore from 'client/components/QuestionTypes/MultipleChoice/MultipleChoiceQuestion.store';
import {Fieldset, Text} from '@albert-io/atomic';
import {OptionEliminatorActions} from 'components/PracticeView/OptionEliminator/OptionEliminator.react';

import multipleChoiceQuestionActions from './MultipleChoiceQuestion.actions';
import MultipleChoiceOption from './MultipleChoiceOption.react';
import OptionEliminatorInputWrapper from './MCQOptionEliminator/MCQOptionEliminator.react';

import './multiple-choice-question.scss';

class MultipleChoiceInputArea extends React.Component {
  static propTypes = {
    isGuessSubmitted: PropTypes.bool,
    storeName: PropTypes.string,
    question: ImmutablePropTypes.record
  };

  static defaultProps = {
    storeName: 'multipleChoiceQuestionStore'
  };

  getStore() {
    return setUpStore(
      MultipleChoiceQuestionStore,
      this.props.storeName,
      this.props.question.getId(),
      this.props.question
    );
  }

  render() {
    const store = this.getStore();
    const options = this.props.question.getOptions();
    const {isGuessSubmitted, question} = this.props;

    /**
     * @todo: Having stores hold onto the rubric doesn't make sense since it's available
     * on the question. We should update other types to do this as well. There's probably
     * more that we can be pulling out of the question directly, rathen than writing these
     * things to the store.
     */
    const rubric = question.getMeta().getQuestionRubric();
    const correctOptions = rubric ? rubric.get('validResponse') : null;
    const isSelectMultiple = question.isSelectMultiple();
    return (
      <div className='u-mar-b_4'>
        {!isGuessSubmitted && <OptionEliminatorActions />}
        <div className='mcq__options-wrapper'>
          <Fieldset>
            {!isGuessSubmitted && (
              <Text as='legend' size='m' className='u-mar-b_2' bold>
                {isSelectMultiple ? 'Select all that apply' : 'Select one answer'}
              </Text>
            )}
            {options.map((option, index) => {
              const optionId = option.getId();
              return (
                <OptionEliminatorInputWrapper
                  questionId={question.getId()}
                  optionId={option}
                  disabled={isGuessSubmitted}
                  onEliminate={() => {
                    callTargetedAction({
                      name: multipleChoiceQuestionActions.REMOVE_OPTION_FROM_SELECTED,
                      payload: optionId,
                      targetStore: store.getName()
                    });
                  }}
                  key={optionId}
                >
                  {(isEliminated) => (
                    <MultipleChoiceOption
                      index={index}
                      option={option}
                      isGuessSubmitted={isGuessSubmitted}
                      isSelected={store.isSelectedOption(optionId)}
                      isCorrectAnswer={correctOptions && correctOptions.has(optionId)}
                      isEliminated={isEliminated}
                      targetStore={store.getName()}
                      isSelectMultiple={isSelectMultiple}
                    />
                  )}
                </OptionEliminatorInputWrapper>
              );
            })}
          </Fieldset>
        </div>
      </div>
    );
  }
}

export {MultipleChoiceInputArea};
